import { getLabel } from "../hooks/use-labels";
import { getConfig } from "../hooks/use-config";
import { validationMessage } from "../utils/validation";
import { countDecimals, phoneInstance } from "../utils/common-utils";

export const extractFormData = (formFields, formData) => {
  const fieldsData = formData || {};
  const required = {};

  for (let key in formFields) {
    const value = formFields[key].value;
    const { elementConfigs } = formFields[key];

    const isString = typeof value === "string";

    if (
      (isString && value.trim()) ||
      ["number", "boolean"].includes(typeof value) ||
      value
    ) {
      const alert = checkInputConstraints(elementConfigs, key, value);
      if (alert) {
        required[key] = alert;
      } else {
        fieldsData[key] = formFields[key].value;
      }
    } else if (!value && elementConfigs.required) {
      required[key] = "Required!";
    }
  }

  return {
    fieldsData,
    required,
  };
};

const checkInputConstraints = (configs, key, value) => {
  const {
    maxLength,
    minLength,
    minValue,
    maxValue,
    maxDecimal,
    validatePhone,
    configErrorMessage,
  } = configs;

  let errorMessage = "";

  switch (true) {
    case maxLength && value.length > maxLength:
      errorMessage = getConfig(key);
      break;
    case minLength && value.length < minLength:
      errorMessage = getConfig(key);
      break;
    case maxLength &&
      minLength &&
      value.length === maxLength &&
      value.length === minLength:
      errorMessage = "";
      break;

    case configs.hasOwnProperty("minValue") && value < minValue:
      errorMessage = getConfig(validationMessage.minimumValue);
      if (errorMessage.includes("{}")) {
        errorMessage = errorMessage.replace("{}", minValue);
      }

      break;

    case configs.hasOwnProperty("maxValue") && value > maxValue:
      if (configErrorMessage) {
        errorMessage = configErrorMessage;
      } else {
        errorMessage = getConfig(validationMessage.maximumValue);
        if (errorMessage.includes("{}")) {
          errorMessage = errorMessage.replace("{}", minValue);
        }
      }
      break;

    case configs.hasOwnProperty("maxDecimal"):
      const decimalCount = countDecimals(value);
      
      if (decimalCount > maxDecimal) {
        errorMessage = getConfig(validationMessage.maxDecimals);
        errorMessage = errorMessage.replace("{}", maxDecimal);
      }

      break;

    case validatePhone:
      try {
        const number = phoneInstance().parseAndKeepRawInput(value, "US");
        const isValid = phoneInstance().isValidNumber(number);

        if (!isValid) {
          errorMessage = getConfig(validationMessage.invalidPhone);
        }
      } catch (error) {
        errorMessage = getConfig(validationMessage.invalidPhone);
      }
      break;

    default:
      return errorMessage;
  }

  return errorMessage;
};

export const getFilledFields = (formFields, fieldValues) => {
  const keys = Object.keys(fieldValues);

  keys.forEach((fieldKey) => {
    if (formFields[fieldKey]) {
      formFields[fieldKey].value = fieldValues[fieldKey];
    }
    if (fieldKey.includes("Title")) {
      const field = fieldKey.split("Title")[0];
      formFields[field].optionTitle = fieldValues[fieldKey];
    }
  });

  return formFields;
};

export const prepareSelectOptions = (options, metaKey, labelKey, valueKey) => {
  return options.map((item) => ({
    label: getLabel(item[metaKey]) || item[labelKey],
    value: item[valueKey],
  }));
};

export const getOptionTitles = (formFields) => {
  const titles = {};

  Object.keys(formFields).forEach((key) => {
    if (formFields[key].optionTitle) {
      titles[key + "Title"] = formFields[key].optionTitle;
    }
  });

  return titles;
};

export const getOptionLabel = (metaKey, labelKey, option) => {
  if (metaKey) {
    return getLabel(option[metaKey]) || option[labelKey];
  }

  return option[labelKey];
};

export const getOptionParameter = ({code, defaultTitle}) => {
  return getLabel(code) || defaultTitle;
}

export const handleLocationField = (locationValue, key, formFields, errors) => {
  const { countryCode, latitude, longitude } = locationValue;

  const fieldErrors = { ...errors };
  let fields = JSON.parse(JSON.stringify(formFields));
  fields[key].value = { latitude, longitude };

  Object.keys(locationValue).forEach((keyItem) => {
    fields[keyItem] && (fields[keyItem].value = locationValue[keyItem]);
    fieldErrors[keyItem] && delete fieldErrors[keyItem];
  });

  fields.stateCode.elementConfigs.apiURL = `/states/${countryCode}`;
  fields.city.elementConfigs.apiURL = `/cities/${countryCode}/${fields.stateCode.value}`;

  return {
    fields,
    fieldErrors,
  };
};
